import types from '@/actions/types';
import useConfig from '@/composables/useConfig';
import { SYSTEM_VARIABLES_MAP } from '@/js/constants';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';

export default class ResetKnowledgeBase extends Base {
  constructor(params) {
    super(params, types.RESET_KNOWLEDGE_BASE);
  }

  execute() {
    const { resetVariables } = useConfig();
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      resetVariables([
        SYSTEM_VARIABLES_MAP.KB_CONVERSATION_HISTORY.id,
        SYSTEM_VARIABLES_MAP.KB_THREAD_ID.id,
      ]);
      resolve();
    });
  }

  stop() {
    this.resolve();
  }
}
